import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';
import { Badge } from '../../components/Badge';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const PromotionBadge = styled(Badge)`
  align-self: flex-end;
`;

export const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[6]};
`;

export const Spacer = styled.div`
  height: ${space[6]};
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: 1.3;
`;

export const CategoryLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: ${space[4]} 0 0;
`;

export const DescriptionSection = styled.div`
  margin-top: ${space[4]};
`;

export const TermsSection = styled.div`
  margin-top: ${space[4]};
`;

export const NotificationSection = styled.div`
  margin-top: ${space[5]};
`;
